document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.multicolumn-list__item').forEach(parent => {
    const child = parent.querySelector('.rte.liquid');
    if (child) {
      const temp = child.cloneNode(true);
      temp.querySelectorAll('style, script').forEach(el => el.remove());
      const content = temp.textContent.trim();
      const hasVisibleContent = content.length > 0;
      if (!hasVisibleContent) {
        parent.remove();
      }
    }
  });
});